// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1qMYf","bigColWidth":"Table_bigColWidth__3sXCp","biggerColWidth":"Table_biggerColWidth__2Yd2r","row":"Table_row__3lJ37","col":"Table_col__3ucBk"};